<template>
  <div>
    <div class="button-group mb-3">
      <span class="text-secondary d-flex" v-for="(btn, index) in buttons" :key="index" @click="handleClick(btn.action)">
        <div :class="btn.action == 'none' ? ' ' : 'pointer a'">
          <i v-if="btn.label == 'Me gusta'" :class="action == true ? 'fa-solid text-primary' : 'fa-regular '" class="fa-heart"></i>

          <i v-if="btn.label == 'Comentarios'" class="fa-solid fa-comments"></i>
          <span class=" " v-if="btn.label == 'Me gusta'">
            {{ blogData.like }}
          </span>
          <span class=" " v-if="btn.label == 'Comentarios'">
            {{ blogData.comments }}
          </span>
          <span> {{ btn.label }} </span>
        </div>
        <span style="opacity: 0.4 !important; font-size: 15px" class="text-secondary pl-2">|</span>
      </span>
    </div>
    <div class="mt-3">
      <h2 class="mb-3" style="font-size: 1.75rem; color: #333; font-weight: 600;">
        {{ blogData.tittle }}
      </h2>
      <div class="blog-detail" v-html="blogData.detail"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blogData: null,
    buttons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeSlide: 0,
      // productImages: [
      // { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      // ],
    };
  },
  methods: {
    handleClick(action) {
      this.$emit("button-click", action);
    },
  },
};
</script>

<style scoped>
a {
  border-bottom: solid var(--black) 1px !important;
  color: var(--black) !important;
  transition: 0.3s !important;
  font-weight: bold !important;
}

a:hover {
  color: var(--primary) !important;
  border-bottom: solid var(--primary) 1px !important;
}

.button-group {
  display: flex;
  gap: 10px;
}

button {
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
}

button:hover {
  background-color: #0056b3;
}

.blog-detail {
  line-height: 1.8;
  color: #495057;
}

.blog-detail :deep(p) {
  margin-bottom: 1rem;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
}

::-webkit-scrollbar-thumb:hover {
  background: transparent;
}

.product-gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-wrapper {
  width: 100%;
  margin-bottom: 15px;
}

.image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.main-image {
  position: relative;
  width: 100vw;
  max-width: 800px;
  max-height: 100%;
}

.thumbnails-wrapper {
  display: flex;
  align-items: center;
}

.thumbnails {
  width: 100vw !important;
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px;
  scroll-behavior: smooth;
}

.thumbnail {
  width: 8rem;
  height: 6rem;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s;
}

.thumbnail.active {
}

.thumbnail:hover {
}

.nav-button {
  margin-top: -1rem;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  border-radius: 100px !important;
  transition: color 0.2s;
}

@media (max-width: 576px) {
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30vh;
  }
}

@media (max-width: 720px) {
  .main-image {
    height: 20vh;
    width: 100vw;
    height: 100%;
  }
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh !important;
  }
}
</style>
